import {
  SET_QUEUE_UI_FLAG,
  CLEAR_QUEUES,
  SET_QUEUES,
  SET_QUEUE_ITEM,
  EDIT_QUEUE,
  DELETE_QUEUE,
} from './types';
import QueuesAPI from '../../../api/queues';

export const actions = {
  get: async ({ commit }) => {
    commit(SET_QUEUE_UI_FLAG, { isFetching: true });
    try {
      const { data } = await QueuesAPI.get();
      commit(CLEAR_QUEUES);
      commit(SET_QUEUES, data);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_QUEUE_UI_FLAG, { isFetching: false });
    }
  },

  // QM §5.4.3 mode 2 — waiting tickets in a queue (browse-and-pick). Transient, not stored.
  // §5.10 — returns the whole { payload, meta } envelope: callers need total_count,
  // which is no longer the same as payload.length now that the list is paged.
  getConversations: async (_ctx, { queueId, page = 1 }) => {
    const { data } = await QueuesAPI.getConversations(queueId, page);
    return data;
  },

  // QM §5.4.3 mode 1 — "Take Next". Returns { conversation_id } or throws
  // (428 confirmation required / 409 / 404 / 403).
  takeNext: async (_ctx, { queueId, confirmed = false }) => {
    const { data } = await QueuesAPI.takeNext(queueId, confirmed);
    return data;
  },

  // QM §5.5.1 — supervisor tile counts. Polled, so kept transient like the
  // drill-down above rather than merged into `records`.
  getOverview: async () => {
    const { data } = await QueuesAPI.getOverview();
    return data.payload;
  },

  // QM §5.4.2 — the agent's own tickets. Transient for the same reason.
  getMyTickets: async () => {
    const { data } = await QueuesAPI.getMyTickets();
    return data.payload;
  },

  // QM §5.5.2 — the two extra drill-down tables. Transient like the rest.
  // §5.10 — paged, so the { payload, meta } envelope is returned whole.
  getAssignedConversations: async (_ctx, { queueId, page = 1 }) => {
    const { data } = await QueuesAPI.getAssignedConversations(queueId, page);
    return data;
  },

  getQueueAgents: async (_ctx, queueId) => {
    const { data } = await QueuesAPI.getAgents(queueId);
    return data.payload;
  },

  // QM §3.1.1 — let the original axios error propagate
  create: async ({ commit }, queueInfo) => {
    commit(SET_QUEUE_UI_FLAG, { isCreating: true });
    try {
      const response = await QueuesAPI.create(queueInfo);
      commit(SET_QUEUE_ITEM, response.data);
      return response.data;
    } finally {
      commit(SET_QUEUE_UI_FLAG, { isCreating: false });
    }
  },

  // QM §3.1.1 — same as `create`: propagate the original error untouched.
  update: async ({ commit }, { id, ...updateObj }) => {
    commit(SET_QUEUE_UI_FLAG, { isUpdating: true });
    try {
      const response = await QueuesAPI.update(id, updateObj);
      commit(EDIT_QUEUE, response.data);
    } finally {
      commit(SET_QUEUE_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, queueId) => {
    commit(SET_QUEUE_UI_FLAG, { isDeleting: true });
    try {
      // Let the original axios error propagate so the caller can surface the
      // backend message (e.g. deletion refused while waiting tickets reside).
      await QueuesAPI.delete(queueId);
      commit(DELETE_QUEUE, queueId);
    } finally {
      commit(SET_QUEUE_UI_FLAG, { isDeleting: false });
    }
  },
};
